import React from "react";
import styles from "./styles.module.css";
import {Link} from "react-router-dom";
import logo from "../../assets/logo2.png";
import {
	FaFacebook,
	FaInstagram,
	FaLinkedinIn,
	FaTwitter,
	FaYoutube,
} from "react-icons/fa";

const Footer = () => {
	const year = new Date().getFullYear();

	return (
		<footer className={styles.footerContainer}>
			<div className={styles.footer}>
				<div className={styles.brandBlock}>
					<Link to="/" className={styles.footerLogo}>
						<img src={logo} alt="Lotus Beta Analytics Logo" />
						<span>LBAN BLOG</span>
					</Link>

					<p>Insights, updates, and stories from Lotus Beta Analytics.</p>
				</div>

				<div className={styles.card}>
					<h4>Explore</h4>
					<ul>
						<li>
							<Link to="/">Home</Link>
						</li>
						<li>
							<Link to="/posts">Posts</Link>
						</li>
						<li>
							<Link to="/microsoft">Microsoft</Link>
						</li>
					</ul>
				</div>

				<div className={styles.card}>
					<h4>Company</h4>
					<ul>
						<li>
							<a
								href="https://lotusbetaanalytics.com"
								target="_blank"
								rel="noreferrer"
							>
								Website
							</a>
						</li>
						{/* <li>
							<Link to="/login">Admin Login</Link>
						</li> */}
					</ul>
				</div>

				<div className={styles.card}>
					<h4>Connect</h4>

					<div className={styles.socials}>
						<a
							href="https://web.facebook.com/lotusbetaanalytics"
							target="_blank"
							rel="noreferrer"
							aria-label="Facebook"
						>
							<FaFacebook />
						</a>

						<a
							href="https://twitter.com/lotusbeta"
							target="_blank"
							rel="noreferrer"
							aria-label="X"
						>
							<FaTwitter />
						</a>

						<a
							href="https://www.instagram.com/lbannigeria"
							target="_blank"
							rel="noreferrer"
							aria-label="Instagram"
						>
							<FaInstagram />
						</a>

						<a
							href="https://www.linkedin.com/company/lotus-beta-analytics"
							target="_blank"
							rel="noreferrer"
							aria-label="LinkedIn"
						>
							<FaLinkedinIn />
						</a>

						<a
							href="https://www.youtube.com/channel/UCOhLIAisZyiolylqVhuq2qg"
							target="_blank"
							rel="noreferrer"
							aria-label="YouTube"
						>
							<FaYoutube />
						</a>
					</div>
				</div>
			</div>

			<div className={styles.rights}>
				<p>&copy; {year} Lotus Beta Analytics. All Rights Reserved.</p>
			</div>
		</footer>
	);
};

export default Footer;
